import { createSlice } from '@reduxjs/toolkit';
import { SkladonMappingsListStateType } from 'src/types/skladonMappingList';

const initialState: SkladonMappingsListStateType = {
    data: null,
    loading: false,
    error: false,
};
export const skladonMappingListSlice = createSlice({
    name: 'skladonMappingList',
    initialState,
    reducers: {
        getSkladonMappingListFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        getSkladonMappingListFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        getSkladonMappingListFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
        clearSkladonMappingList: (state) => {
            state.data = null;
            state.loading = false;
            state.error = false;
        },
    },
});

export const {
    getSkladonMappingListFetch,
    getSkladonMappingListFetchSuccess,
    getSkladonMappingListFetchFailure,
    clearSkladonMappingList,
} = skladonMappingListSlice.actions;

export default skladonMappingListSlice.reducer;
